export default __webpack_public_path__ + "locales/ko-KR/Notifications.json?hash=a597d81ab137e0fa5b70d2f5ddc41e43";